import React, {useEffect} from 'react';
import {onAuthStateChanged} from 'firebase/auth';
import {auth} from '../../firebase';

import {getDebug} from '../../library/GeneralUse';
import {
	incrementSigninCount,
	syncAppAndFirestore,
} from '../../library/FirestoreUser';

import {useFirebaseAuthUserStore} from '../../stores/FirebaseAuthUserStore';
import {useFirestoreUserStore} from '../../stores/FirestoreUserStore';

const DEBUG = getDebug('auth');

export const HandleAuthAndState = () => {
	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
			DEBUG && console.groupCollapsed(`onAuthStateChanged()`);

			// Zustand
			const setFirebaseAuthUser =
				useFirebaseAuthUserStore.getState().setFirebaseAuthUser;
			const setFirestoreUser =
				useFirestoreUserStore.getState().setFirestoreUser;
			setFirebaseAuthUser(user);

			if (user) {
				DEBUG &&
					console.groupCollapsed(
						'Firebase Auth user exists. Synchronising with Firestore',
					);

				await syncAppAndFirestore();

				DEBUG && console.groupEnd();
				DEBUG &&
					console.info(`We have successfully:
1. Checked if the Google (i.e. Firebase Auth) user exists in the users collection in Firestore, and if not, created them
2. Synchronised Zustand firestoreUser with live Firestore user`);

				DEBUG &&
					console.groupCollapsed('Increment Firestore user signin_count');
				await incrementSigninCount();

				DEBUG && console.groupEnd();
			} else {
				DEBUG &&
					console.log(
						`Firebase Auth user does not exist - we may have signed out or simply have not authenticated ourselves`,
					);

				setFirestoreUser(null);
			}

			DEBUG && console.groupEnd();
		});

		// Unsubscribe from the listener when the component is unmounted.
		return () => {
			unsubscribe();
		};
	}, []);

	return <></>;
};
